import { createContext } from "react";

const LogScreen = createContext<any>(null);

export default LogScreen;
